import { AgentRequest } from '~/protos/agents'
import { resolveApiUrl } from '~/utils/apiUrl'
import { getDeviceId } from '~/utils/storage'

export async function submitCampaignTask(request: AgentRequest) {
  const response = await fetch(resolveApiUrl('/api/campaign/task-submit'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/octet-stream',
      'X-DEVICE-ID': request.deviceId
    },
    body: AgentRequest.encode(request).finish() as unknown as BodyInit
  })

  if (!response.ok) {
    const { detail: reason } = await response.json()
    throw new Error(reason)
  }

  return response.json() as unknown as { taskId: number }
}

export async function isEmailSet(): Promise<boolean> {
  const uid = getDeviceId()
  const response = await fetch(resolveApiUrl('/api/campaign/user'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ uid })
  })

  if (!response.ok) {
    const { detail: reason } = await response.json()
    throw new Error(reason)
  }
  const { is_email_set } = (await response.json()) as unknown as { is_email_set: boolean }
  return is_email_set
}
